import { clearDefaultOptions } from '../actions/clearDefaultOptions';
import getStore from '../store/store';
import { mutator } from 'satcheljs';

export const clearDefaultOptionsMutator = mutator(clearDefaultOptions, actionMessage => {
    const store = getStore();
    store.critiqueTypeCategoryNames.clear();
    store.defaultOptionsUI.clear();
    store.defaultOptionsEditor.clear();
});
